import React, { useEffect, useState } from "react"
import './Axis.css'
import axios from "../../API/axiosConfig";
import { currentLanguage } from "../../algorithms/storage";
import Chart from "react-apexcharts";
import { handleCatchErrors, responseDataFormat } from "../../API/middlewares/resolveRequests";
import { getMembersStatusApi } from "../../API/services/homepage";
import { getAxisTableData } from "../../API/services/Reports/report";
import { Link } from "react-router-dom";
import BackIcon from "../BackIcon/BackIcon";
const Axis = ({userToken}) => {
    const [data, setData] = useState(null)
    const getAxisTable = async (userToken) => {
        let response;
        try{
        response = await axios.get('Task/GetAxisTable', {
            headers: {
              Authorization: `Bearer ${userToken}`,
              "Accept-Language": currentLanguage(),
            },
          });
        }catch(error){
          response = error
        }finally{
            setData(response)
        }
    }
    useEffect(() => {
      getAxisTable(userToken)
    },[])
    const [charttData, setChartData] = useState();
    const getMembersStatus = async () => {
        let response;
        try {
          response = await getAxisTableData(userToken);
          setChartData(response);
        } catch (e) {
          response = handleCatchErrors(e);
        } finally {
          return responseDataFormat(response);
        }
      };
      const state = {
        options: {
          chart: {
            stacked: true,
            zoom: {
              enabled: false,
            },
            parentHeightOffset: 0,
            toolbar: {
              show: false,
            },
          },
    
          legend: {
            show: true,
            showForSingleSeries: false,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: "bottom",
            horizontalAlign: "center",
            floating: false,
            fontSize: "15px",
            fontFamily: "gssLight",
            fontWeight: 400,
            formatter: undefined,
            inverseOrder: false,
            width: undefined,
            height: undefined,
            tooltipHoverFormatter: undefined,
            customLegendItems: [],
            offsetX: 0,
            offsetY: 10,
            labels: {
              colors: undefined,
              useSeriesColors: false,
            },
            markers: {
              width: 12,
              height: 12,
              strokeWidth: 0,
              strokeColor: "#fff",
              fillColors: undefined,
              radius: 12,
              customHTML: undefined,
              onClick: undefined,
              offsetX: 3,
              offsetY: 0,
            },
            itemMargin: {
              horizontal: 10,
              vertical: 10,
            },
            onItemClick: {
              toggleDataSeries: true,
            },
            onItemHover: {
              highlightDataSeries: true,
            },
          },
    
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: ["#fff"],
            colors: ["#00F"],
          },
    
          stroke: {
            curve: "straight",
          },
          // colors: ["#0085b6", "#00d39c", "#ff0000"],
          colors: ["#52bc57", "#fcc717", "#ff0000",'#3444ae'],
          xaxis: {
            crosshairs: {
              show: false,
            },
            labels: {
              style: {
                fontSize: "18px",
                fontWeight: 600,
                fontFamily: "gssLight",
              },
              offsetY: 5,
            },
            axisBorder: {
              show: true,
              color: "#78909C",
              height: 1,
              width: "100%",
              offsetX: 0,
              offsetY: 0,
            },
            axisTicks: {
              show: true,
              borderType: "solid",
              color: "#78909C",
              height: 6,
              offsetX: 0,
              offsetY: 0,
            },
            title: {
              text: "المحاور المسئولة",
              offsetX: 0,
              offsetY: 10,
              style: {
                color: undefined,
                fontSize: 25,
                fontFamily: "gssLight",
                fontWeight: 600,
                cssClass: "apexcharts-xaxis-title",
              },
            },
            categories: charttData?.data?.data?.pivots?.map((item, index) => {
              return item?.name;
            }),
          },
          yaxis: {
            crosshairs: {
              show: false,
            },
            labels: {
              style: {
                fontSize: "16px",
                fontFamily: "gssLight",
                fontWeight: 500,
              },
              rotate: 0,
              offsetX: 0,
              offsetY: 0,
            },
            axisBorder: {
              show: true,
              color: "#78909C",
              width: 1,
              height: "100%",
              offsetX: 5,
              offsetY: 0,
            },
            axisTicks: {
              show: true,
              borderType: "solid",
              color: "#78909C",
              height: 5,
              offsetX: 0,
              offsetY: 0,
            },
            title: {
              text: "عدد الإجراءات",
              offsetX: -140,
              offsetY: -100,
              style: {
                color: undefined,
                fontSize: 25,
                fontFamily: "gssLight",
                fontWeight: 600,
                cssClass: "apexcharts-xaxis-title",
              },
            },
          },
        },
        tooltip: {
          custom(data) {
            return `<div className='px-1 py-50'>
                    <span>${
                      data?.series[data?.seriesIndex][data?.dataPointIndex]
                    } %</span>
                  </div>`;
          },
        },
    
        series: [
          {
            name: "تم",
            data: charttData?.data?.data?.pivots?.map((item, index) => {
              return item?.tasksFinished;
            }),
          },
          {
            name: "متوقف",
            data: charttData?.data?.data?.pivots?.map((item, index) => {
              return item?.tasksNotStarted;
            }),
          },
          {
            name: "متأخر",
            data:charttData?.data?.data?.pivots?.map((item, index) => {
              return item?.tasksLate;
            }),
          },
          {
            name: "جارى",
            data:charttData?.data?.data?.pivots?.map((item, index) => {
              return item?.tasksCurrent;
            }),
          },
        ],
      };
  useEffect(() => {
    getMembersStatus();
  }, []);
    return (
        <div className="py-5 px-4">
          <div className="ctr" style={{display:"flex", justifyContent:"flex-end", margin:"0 20px", position:"relative", zIndex:"10"}}>
      <BackIcon/>
      </div>
            <div className="report_table">
                <table>
                    <thead>
                        <tr>
                            <th>المحور</th>
                            <th>اجمالى عددالإجراءات</th>
                            <th>تم</th>
                            <th>متوقف</th>
                            <th>متأخر</th>
                            <th>جارى</th>
                        </tr>
                    </thead>
                    <tbody>
                         {data?.data?.data?.pivots?.map(el => (
                            <tr key={el?.id}>
                            <td><Link to={'/entityAxis'}  state={{id:el?.id}} style={{
                              textDecoration:"none",
                              color:"black"
                            }}>{el?.name}</Link></td>
                            <td>{el?.taskCount}</td>
                            <td>{el?.tasksFinished}</td>
                            <td>{el?.tasksNotStarted}</td>
                            <td>{el?.tasksLate}</td>
                            <td>{el?.tasksCurrent}</td>
                        </tr>
                         ))}
                      
                    </tbody>
                </table>

            </div>
            {charttData &&  <div className="my-5">
            <Chart
              options={state.options}
              series={state.series}
              type="bar"
              // width="100%"
              height={"800px"}
            />
            </div>}
           
        </div>
    )
}
export default Axis